import { useContext } from "react";
import RouteManagerContext from "./RouteManagerContext";

/**
 * Custom hook to access RouteManager context
 * Provides route management functionality including route filtering, current route data, and URL utilities
 * @returns {import("./RouteManagerContext").RouteManagerContextValue} Route manager context value
 * @throws {Error} When used outside of RouteManagerProvider
 */
export const useRouteManager = () => {
  const context = useContext(RouteManagerContext);
  if (!context) {
    throw new Error(
      "useRouteManager must be used within a RouteManagerProvider."
    );
  }
  return context;
};
